<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form
        ref="storeForm"
        :model="formData"
        :rules="rules"
        label-width="140px"
        label-position="left"
        size="mini"
      >
        <p class="title mB-30">基本信息</p>
        <el-form-item label="门店名称" prop="storeName">
          <el-input :disabled="$route.query.type==='1'|| disabledReject('storeName')" v-model="formData.storeName" placeholder="请输入门店名称"></el-input>
          <div class="rejectedDiv" v-if="rejectedShow('storeName')">
            <span class="rejectedSpan">审核中</span>
            <el-input disabled v-model="formData.verifyFields.storeName"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="所在外卖平台" prop="takeawayClient">
          <static-selector :disabled="$route.query.type==='1'" @update:value="handleChangeTakeawayClient" :value.sync="formData.takeawayClient" type="takeawayClient"></static-selector>
        </el-form-item>
        <el-form-item label="外卖平台门店名称" prop="takeawayStoreName">
          <el-input placeholder="请输入外卖平台门店名称" :disabled="formData.takeawayClient===0 || $route.query.type==='1'" v-model="formData.takeawayStoreName"></el-input>
        </el-form-item>
        <el-form-item label="外卖平台门店电话" prop="takeawayStorePhone">
          <el-input placeholder="请输入外卖平台门店电话" :disabled="formData.takeawayClient===0 || $route.query.type==='1'" v-model="formData.takeawayStorePhone"></el-input>
        </el-form-item>
        <el-form-item label="门店地址" prop="addressDetail">
          <cascader-address
            :provinceId.sync="formData.provinceId"
            :cityId.sync="formData.cityId"
            :areaId.sync="formData.regionId"
            :ywCityId.sync="formData.ywCityId"
            :value="value"
            :text.sync="text"
            :disabled="!(formData.verifyStatus===3) || $route.query.type==='1' || disabledReject('provinceId')"
            style="display: inline;"
          />
          <div class="rejectedDiv" v-if="rejectedShow('provinceId')">
            <span class="rejectedSpan">审核中</span>
            <cascader-address
            disabled
            :value="[formData.verifyFields.provinceId, formData.verifyFields.cityId, formData.verifyFields.regionId]"
            style="display: inline;"
          />
          </div>
          <br />
          <el-input
            :disabled="!(formData.verifyStatus===3) || $route.query.type==='1' || disabledReject('provinceId')"
            style="margin-top: 20px;"
            v-model="formData.address"
            placeholder="请输入门店地址信息"
          ></el-input>
          <div class="rejectedDiv" v-if="rejectedShow('provinceId')">
            <span class="rejectedSpan">审核中</span>
            <el-input
              style="margin-top: 20px;"
              disabled
              v-model="formData.verifyFields.address"
              placeholder="请输入门店地址信息"
            ></el-input>
          </div>
          <el-button
            v-if="(formData.verifyStatus===3)"
            class="marLeft10"
            @click="()=>{ $refs.map.search() }"
          >定位</el-button>
          <edit-address
            v-if="!(formData.verifyStatus===3 || formData.verifyStatus===1) && !rejectedShow('provinceId')"
            :value="value"
            :text-address="formData.address"
            :text-address-detail="formData.addressDetail"
            :storeId="formData.storeId"
            @success="getStoreDetail"
          />
        </el-form-item>
        <el-form-item label="定位地址" prop="address">
          <el-input :disabled="true" v-model="formData.addressDetail"></el-input>
          <div class="rejectedDiv" v-if="rejectedShow('provinceId')">
            <span class="rejectedSpan">审核中</span>
            <el-input disabled v-model="formData.verifyFields.addressDetail" placeholder="请输入门店详细地址，精确到门牌号"></el-input>
          </div>
        </el-form-item>
        <map-address
          ref="map"
          v-if="formData.verifyStatus === 3 && $route.query.type!=='1'"
          style="margin-bottom: 10px"
          :keyword="`${text.join('')}${formData.address}`"
          @point="getPoint"
        />
        <el-form-item label="联系人姓名" prop="personName">
          <el-input :disabled="$route.query.type==='1'"  v-model="formData.personName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="personPhone">
          <el-input :disabled="$route.query.type==='1'" v-model="formData.personPhone" placeholder="请输入联系人手机号"></el-input>
        </el-form-item>
        <el-form-item label="门店类型" prop="storeManagementType">
          <!-- <el-select v-model="formData.a"></el-select> -->
          <store-types
            :classA.sync="formData.classA"
            :classB.sync="formData.classB"
            :classC.sync="formData.classC"
            :classCNeed.sync="classCNeed"
            :classAName.sync="formData.classAName"
            :classBName.sync="formData.classBName"
            :classCName.sync="formData.classCName"
            :text="textValue"
            :disabled="$route.query.type==='1' || disabledReject('classA')"
            style="display: inline;"
          ></store-types>
          <div class="rejectedDiv" v-if="rejectedShow('classA')">
            <span class="rejectedSpan">审核中</span>
            <store-types
            disabled
            type="edit"
            :text="[formData.verifyFields.classA, formData.verifyFields.classB, formData.verifyFields.classC]"
            style="display: inline;"
          ></store-types>
          </div>
          <p
            v-if="$store.state.systemConfig.managementType.length> 1"
            style="color: red;display: inline;margin-left: 20px;"
          >暂无“客户类型”，请联系销售补充客户类型</p>
        </el-form-item>
        <el-form-item label="经营场所" prop="placeId">
          <static-selector
            :disabled="$route.query.type==='1' || disabledReject('placeId')"
            :value.sync="formData.placeId"
            type="place"
          />
          <div class="rejectedDiv" v-if="rejectedShow('placeId')">
            <span class="rejectedSpan">审核中</span>
            <static-selector disabled :value.sync="formData.verifyFields.placeId" type="place"></static-selector>
          </div>
        </el-form-item>
        <el-form-item v-if="isShowTs" label="团膳经营类型" prop="tsId">
          <static-selector
            :disabled="$route.query.type==='1'"
            :value.sync="formData.tsId"
            type="tsType"
          />
        </el-form-item>
        <el-form-item label="门店图片" prop="storeImg">
          <p>门脸照</p>
          <store-img-upload style="display:inline; width:450px;" :disabled="$route.query.type==='1' || disabledReject('doorFacePic')" type="doorFacePic" :imgUrls="doorFacePic" @fileList="(data) => formData.doorFacePic= data"/>
          <div class="rejectedDiv" v-if="rejectedShow('doorFacePic')">
            <span class="rejectedSpan">审核中</span>
            <store-img-upload style="display:inline;" :disabled="true" type="doorFacePic" :imgUrls="formData.verifyFields.doorFacePic"/>
          </div>
          <p>注：门脸照需拍出完整门匾,门框,需在餐厅开门营业状态下完成拍摄(建议正对门店2米处拍摄) 。支持JPG, JPEG,PNG等格式大小不超过5M</p>
          <p>店内照</p>
          <store-img-upload style="display:inline;" :disabled="$route.query.type==='1' || disabledReject('shopInPic')" type="shopInPic" :imgUrls="shopInPic" @fileList="(data) => formData.shopInPic= data"/>
          <div class="rejectedDiv" v-if="rejectedShow('shopInPic')">
            <span class="rejectedSpan">审核中</span>
            <store-img-upload style="display:inline;" :disabled="true" type="shopInPic" :imgUrls="formData.verifyFields.shopInPic"/>
          </div>
          <p>注：店内照需真实反映用餐环境(收银台,用餐桌椅等)。支持JPG, JPEG,PNG等格式大小不超过5M</p>
        </el-form-item>
        <el-form-item label="营业执照" prop="licensePic">
          <store-img-upload style="display:inline;" v-if="$route.query.type==='2' && !disabledReject('licensePic')" :limit="1" type="licensePic" :imgUrls="licensePic" @fileList="(data) => formData.licensePic= data[0]"/>
          <img-upload style="display: inline-block;vertical-align: top;" v-else disabled :fileList="licensePic" @getFileList="(data) => formData.licensePic= data"/>
          <div class="rejectedDiv" v-if="rejectedShow('licensePic')">
            <span class="rejectedSpan">审核中</span>
            <img-upload disabled :fileList="formData.verifyFields.licensePic" style="display:inline-block;"/>
          </div>
          <p>注：用于门店开票审核，请准确填写，支持JPG, JPEG,PNG等格式大小不超过5M</p>
        </el-form-item>
        <el-form-item label="营业执照名称" prop="licenseName">
          <el-input :disabled="$route.query.type==='1' || disabledReject('licensePic')" v-model.trim="formData.licenseName"></el-input>
          <div class="rejectedDiv" v-if="rejectedShow('licensePic')">
            <span class="rejectedSpan">审核中</span>
            <el-input disabled v-model="formData.verifyFields.licenseName" placeholder="请输入营业执照上的名称"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="注册号" prop="regNum">
          <el-input :disabled="$route.query.type==='1' || disabledReject('licensePic')" v-model.trim="formData.regNum" placeholder="请输入注册号（统一信用代码）"></el-input>
          <div class="rejectedDiv" v-if="rejectedShow('licensePic')">
            <span class="rejectedSpan">审核中</span>
            <el-input disabled v-model="formData.verifyFields.regNum"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="有效期" prop="expireType">
          <el-radio :disabled="$route.query.type==='1' || disabledReject('licensePic')" v-model="formData.expireType" :label="1">固定有效日期</el-radio>
          <el-date-picker
            v-model="formData.expireDate"
            :disabled="formData.expireType!== 1||$route.query.type==='1' || disabledReject('licensePic')"
            v-if="formData.expireType=== 1"
            type="date"
            :picker-options="pickerOptions"
            :default-value="new Date()"
            style="margin-right: 20px;"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择日期" />
          <el-radio :disabled="$route.query.type==='1' || disabledReject('licensePic')" v-model="formData.expireType" :label="2">长久有效</el-radio>
          <div class="rejectedDiv" v-if="rejectedShow('licensePic')">
            <span class="rejectedSpan">审核中</span>
            <el-radio disabled v-model="formData.verifyFields.expireType" :label="1">固定有效日期</el-radio>
            <el-date-picker
              v-model="formData.verifyFields.expireDate"
              disabled
              v-if="formData.verifyFields.expireType=== 1"
              type="date"
              :default-value="new Date()"
              style="margin-right: 20px;"
              format="yyyy-MM-dd"
              value-format="timestamp"
              placeholder="选择日期">
            </el-date-picker>
            <el-radio disabled v-model="formData.verifyFields.expireType" :label="2">长久有效</el-radio>
          </div>
        </el-form-item>
        <el-form-item label="楼层" prop="floor">
          <static-selector
            :disabled="$route.query.type==='1'"
            :value.sync="formData.floor"
            type="floor"
          />
        </el-form-item>
        <el-form-item label="电梯" prop="hasLift">
          <el-radio :disabled="$route.query.type==='1'" v-model="formData.hasLift" :label="1">有</el-radio>
          <el-radio :disabled="$route.query.type==='1'" v-model="formData.hasLift" :label="0">无</el-radio>
        </el-form-item>
        <p class="title">服务信息</p>
        <el-form-item label="收货时间" prop="receiveTime">
          <get-goods-time
            :disabled="$route.query.type==='1' || disabledReject('receiveStartTime')"
            :receiveStartTime.sync="formData.receiveStartTime"
            :receiveEndTime.sync="formData.receiveEndTime"
            :text="timeText"
            style="display: inline-block;"
          />
          <div class="rejectedDiv" v-if="rejectedShow('receiveStartTime')">
            <span class="rejectedSpan">审核中</span>
            <get-goods-time
            disabled
            style="display: inline-block;"
            :text="[formData.verifyFields.receiveStartTime, formData.verifyFields.receiveEndTime]"
          />
          </div>
        </el-form-item>
        <el-form-item label="门店备注">
          <el-input
            :disabled="$route.query.type==='1'"
            v-model="formData.desc"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请详细描述门店细节，例如门店是否有地下车库、如有是否限高；门店周围是否方便停车等"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店起送价">
          <p>{{formData.minimumQuantity}}元</p>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div v-if="$route.query.type!=='1'" style="display:inline-block;">
          <el-button size="mini" @click="handleBack">取消</el-button>
          <el-button size="mini" type="primary" @click="onSubmit">保存并提交</el-button>
          <audit-dialog typeKey="store" :formData="{storeId: formData.storeId, applyId: formData.applyId, commitWay: 0}"></audit-dialog>
        </div>
        <div v-else>
          <el-button size="mini" @click="handleBack">返回</el-button>
          <audit-dialog typeKey="store" :formData="{storeId: formData.storeId, applyId: formData.applyId,}"></audit-dialog>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import editAddress from "./editAddress/index.vue";
export default {
  components: {
    editAddress
  },
  data() {
    var checkRegNum = (rules, val, callback) => {
      if(!val) callback(new Error("请输入注册号"))
      else if(val.length> 20) callback(new Error("注册号不得超过20位"))
      callback()
    }
    var checkLisenceName = (rules, val, callback) => {
      if(!val) callback(new Error("请输入营业执照名称"))
      else if(val.length> 32) callback(new Error("营业执照名称不得超过32位"))
      callback()
    }
    var checkStoreName = (rules, val, callback) => {
      if (this.formData.storeName.length > 25)
        callback(new Error("门店名称不超过25字"));
      if (this.formData.storeName.length === 0)
        callback(new Error("门店名称不能为空"));
      callback();
    };
    var checkAddressDetail = (rules, val, callback) => {
      const { provinceId, cityId, addressDetail } = this.formData;
      if (this.$route.query.type === "1" || this.formData.verifyStatus !== 3)
        callback();
      if (provinceId && cityId && addressDetail) {
        callback();
      }
      callback(new Error(rules.message));
    };
    var checkReceiveTime = (rules, val, callback) => {
      const { receiveStartTime, receiveEndTime } = this.formData;
      if (this.$route.query.type === "1") callback();
      if (receiveStartTime && receiveEndTime) {
        callback();
      }
      callback(new Error(rules.message));
    };
    var checkStoreManagement = (rules, val, callback) => {
      const { classA, classB, classCNeed, classC } = this.formData;
      if (this.$route.query.type === "1") callback();
      if (!classA || !classB) {
        callback(new Error(rules.message));
      }
      if (this.classCNeed && classC.length === 0) {
        callback(new Error(rules.message));
      }
      callback();
    };
    var checkStoreImg= (rules, val, callback)=> {
      const {doorFacePic, shopInPic}= this.formData
      if((doorFacePic.length+ shopInPic.length)< 1) callback(new Error("门脸照，店内照两者至少上传一张"))
      callback()
    }
    var checkLicensePic=  (rules, val, callback)=> {
      const {licensePic}= this.formData
      if(licensePic=== "") callback(new Error("请上传营业执照"))
      callback()
    }
    var checkExpireType= (rules, val, callback)=> {
      const {expireType, expireDate}= this.formData
      if(expireType=== 1 && !expireDate) callback(new Error("请选择固定有效日期"))
      callback()
    }
    var checkTsId= (rules, val, callback) => {
      if(val=== 0) callback(new Error(rules.message))
      callback()
    }
    return {
      formData: {
        storeName: "",
        classA: "",
        classB: "",
        classC: [],
        personName: "",
        personPhone: "",
        ywCityId: "",
        receiveStartTime: "",
        minimumQuantity: "",
        receiveEndTime: "",
        hasLift: 1,
        floor: "",
        address: "",
        addressDetail: "",
        lng: "",
        lat: "",
        verifyStatus: "",
        placeId: "",
        branchMark: "",
        tsId: 0,
        title: "",
        provinceId: "",
        cityId: "",
        regionId: "",
        desc: "",
        doorFacePic: [],
        shopInPic: [],
        licensePic: '',
        licenseName: '',
        regNum: '',
        expireType: 1,
        expireDate: '',
        verifyFields: {},
        takeawayClient: 0,
        takeawayStoreName: '-',
        takeawayStorePhone: '-'
      },
      doorFacePic: [],
      shopInPic: [],
      licensePic: '',
      classCNeed: false,
      text: [],
      value: [],
      timeText: [],
      textValue: [],
      startTime: "",
      endTime: "",
      rules: {
        storeName: [
          {
            required: true,
            validator: checkStoreName
          }
        ],
        personName: [{ required: true, message: "请输入联系人姓名" }],
        personPhone: [{ required: true, message: "请输入联系人电话" }],
        receiveTime: [
          {
            validator: checkReceiveTime,
            required: true,
            message: "请填写送货时间"
          }
        ],
        hasLift: [
          {
            required: true,
            message: "请选择是否有电梯"
          }
        ],
        floor: [
          {
            required: true,
            message: "请选择楼层"
          }
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址"
          }
        ],
        addressDetail: [
          {
            validator: checkAddressDetail,
            required: true,
            message: "请填写门店地址信息"
          }
        ],
        placeId: [
          {
            required: true,
            message: "请选择经营场所"
          }
        ],
        tsId: [
          {
            required: true,
            validator: checkTsId,
            message: "请选择团膳经营类型"
          }
        ],
        storeManagementType: [
          {
            required: true,
            validator: checkStoreManagement,
            message: "请填写完整"
          }
        ],
        storeImg: [{required: true, validator: checkStoreImg}],
        licenseName: [{required: true, validator: checkLisenceName}],
        regNum: [{required: true, validator: checkRegNum}],
        expireType: [{required: true, validator: checkExpireType}],
        licensePic: [{required: true, validator: checkLicensePic}]
      },
      echoData: true,
      isShowTs: false,
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date()
          const year = now.getFullYear()
          const month = now.getMonth()
          const day = now.getDate()-1
          return time.getTime() < new Date(year, month, day, 23, 59, 59).getTime()
        }
      },
    };
  },

  async created() {
    await this.getIsShowTs();
    this.getStoreDetail();
  },
  methods: {
    disabledReject(key) {
      return  this.$route.query.type === '2' &&this.formData.verifyFields && Object.keys(this.formData.verifyFields).indexOf(key)!== -1;
    },
    handleBack() {
      this.$router.go(-1);
    },
    async getIsShowTs() {
      const { ret, data } = await _api.store.isShowTs();
      if (ret && data) {
        this.isShowTs = data;
      }
    },
    async getStoreDetail() {
      const { ret, data: formData } = await _api.store.getStoreDetail({
        storeId: this.$route.query.storeId,
        applyId: this.$route.query.applyId
      });
      if (ret && formData) {
        if (formData.verifyStatus === 3 && this.$route.query.type !== "1") {
          Object.assign(formData, {
            provinceId: "",
            cityId: "",
            regionId: "",
            address: "",
            addressDetail: "",
            takeawayClient: 0,
            takeawayStoreName: '-',
            takeawayStorePhone: '-'
          });
        }
        const {
          provinceId,
          cityId,
          regionId,
          classA,
          classB,
          classC,
          receiveStartTime,
          receiveEndTime,
          doorFacePic,
          shopInPic,
          tsId,
          licensePic,
          expireDate,
          takeawayClient
        } = formData;
        Object.assign(this, {
          formData,
          value: [provinceId, cityId, regionId],
          textValue: [classA, classB, classC],
          timeText: [receiveStartTime, receiveEndTime],
          doorFacePic,
          shopInPic,
          licensePic
        });
        this.formData.expireDate= expireDate? expireDate*1000: "";
        this.formData.tsId = !this.formData.tsId && this.isShowTs? "" : this.formData.tsId;
        if(this.formData.verifyFields && this.formData.verifyFields.expireDate){
          this.formData.verifyFields.expireDate*=1000
        }
        if(takeawayClient === 0) {
          this.formData.takeawayStoreName = '-';
          this.formData.takeawayStorePhone = '-';
        }
      }
    },
    onSubmit() {
      const { takeawayClient, takeawayStoreName, takeawayStorePhone } = this.formData;
      if(takeawayClient !== 0) {
        if(!takeawayStoreName) {
          return this.$message.error("请输入外卖平台门店名称")
        }
        if(!takeawayStorePhone) {
          return this.$message.error("请输入外卖平台门店电话")
        }
      }
      this.$refs["storeForm"].validate(val => {
        if (val) {
          this.save();
        } else {
          this.$message({
            type: "warning",
            message: "请完善信息后提交"
          });
        }
      });
    },
    async save() {
      if(this.formData.expireType=== 2) this.formData.expireDate= new Date().getTime()
      this.formData.expireDate/= 1000
      const { ret, data } = await _api.store.editSubmit(this.formData);
      if (ret && data) {
        this.$message({
          type: "success",
          message: "编辑成功"
        });
        this.$router.go(-1);
      }
    },
    getPoint(info) {
      this.formData.address = info.title;
      this.formData.lng = info.point.lng;
      this.formData.lat = info.point.lat;
      this.formData.addressDetail = info.address;
    },
    rejectedShow(key) {
      return this.formData.verifyFields && Object.keys(this.formData.verifyFields).indexOf(key) !== -1;
    },
    handleChangeTakeawayClient(value) {
      const { takeawayClient, takeawayStoreName, takeawayStorePhone } = this.formData || {};
      if(value === 0) {
        this.formData.takeawayStoreName = '-';
        this.formData.takeawayStorePhone = '-';
      } else if(value !== 0 && takeawayStoreName === '-' && takeawayStorePhone === '-') {
        this.formData.takeawayStoreName = '';
        this.formData.takeawayStorePhone = '';
      }
      console.log('handleChangeTakeawayClient2', this.formData)
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 300px;
}
.el-textarea {
  width: 400px;
}
.el-select {
  width: 130px;
}
.title {
  font-weight: 900;
  font-size: 16px;
}
</style>
